import React from 'react';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';
import { Box, Heading, Text } from '@radix-ui/themes';

import './style.scss';

export default function PageTitle({ icon, title }) {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';
  return (
    <>
      {!isMobile ? (
        <Heading as="h3" className={`title3 page-title ${icon}`}>
          {title}
        </Heading>
      ) : (
        <Box className="page-title-box">
          <Text as="p" className={`title5 page-title ${icon}`}>
            {title}
          </Text>
        </Box>
      )}
    </>
  );
}
